import React from 'react';
import { FlexBox } from '@eltoro-ui/components';
import { Skeleton } from 'primereact/skeleton';
import '../GeneratedCreatives.scss';

const SkeletonConnecting = () => {
  return (
    <FlexBox
      flexDirection="column"
      justifyContent="space-between"
      UNSAFE_className="connect-skeleton-wrapper"
    >
      <FlexBox flexDirection="column" gap="16px" UNSAFE_className="chat-content">
        <FlexBox gap="8px" alignSelf="flex-start">
          <Skeleton size="3rem" shape="circle" className="connect-skeleton" />
          <Skeleton width="16rem" height="3rem" borderRadius="6px" className="connect-skeleton" />
        </FlexBox>
        <FlexBox gap="8px" alignSelf="flex-end">
          <Skeleton width="16rem" height="3rem" borderRadius="6px" className="connect-skeleton" />
          <Skeleton size="3rem" shape="circle" className="connect-skeleton" />
        </FlexBox>
        <FlexBox gap="8px" alignSelf="flex-start">
          <Skeleton size="3rem" shape="circle" className="connect-skeleton" />
          <Skeleton width="16rem" height="3rem" borderRadius="6px" className="connect-skeleton" />
        </FlexBox>
        <FlexBox gap="8px" alignSelf="flex-end">
          <Skeleton width="16rem" height="3rem" borderRadius="6px" className="connect-skeleton" />
          <Skeleton size="3rem" shape="circle" className="connect-skeleton" />
        </FlexBox>
        <FlexBox gap="8px" alignSelf="flex-start">
          <Skeleton size="3rem" shape="circle" className="connect-skeleton" />
          <Skeleton width="16rem" height="3rem" borderRadius="6px" className="connect-skeleton" />
        </FlexBox>
        <FlexBox gap="8px" alignSelf="flex-end">
          <Skeleton width="16rem" height="3rem" borderRadius="6px" className="connect-skeleton" />
          <Skeleton size="3rem" shape="circle" className="connect-skeleton" />
        </FlexBox>
        <FlexBox gap="8px" alignSelf="flex-start">
          <Skeleton size="3rem" shape="circle" className="connect-skeleton" />
          <Skeleton width="16rem" height="3rem" borderRadius="6px" className="connect-skeleton" />
        </FlexBox>
      </FlexBox>
      <FlexBox>
        <Skeleton width="100%" height="150px" borderRadius="6px" className="connect-skeleton" />
      </FlexBox>
    </FlexBox>
  );
};
export default SkeletonConnecting;
